import { Alert, Box, Row } from "@intech/web-ui";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const Label = styled.div`
  margin-bottom: 10px;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
 `;

export const TH = styled.th`
  vertical-align: bottom;
  text-align: left;
  border-bottom: 2px solid #dee2e6;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  color: #212529;
  border-collapse: collapse;
  ${props => `${props.style}`}
`;

export const TD = styled.td`
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
  color: #212529;
  border-collapse: collapse;
  font-size: 11px;
`;

export const StrippedRow = styled.tr`
  &:nth-of-type(2n+1) {
    background-color: rgba(0,0,0,0.09);
  }
`;

export const CenteredRow = styled(Row)`
  align-items: center;
`;

export const SmallButton = styled(Link)`
  color: #fff;
  background-color: #2C688D;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  border: 1px solid #2C688D;;
  padding: 0.375rem 0.75rem;
  font-size: 10px;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  text-decoration: none;
  align-self: end;
`;

export const LinkPastaAtual = styled.span`
  margin-left: 4px;
  color: #17a2b8;
`;
